import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit/dist/createAction";

import {
    asyncDeleteOrderAction,
    asyncUpdateOrderAction,
    asyncGetOrdersAction, asyncGetOrderAction,
} from "./ordersAction";
import { IOrder } from "../../../helpers/types";
import { toast } from "react-toastify";
import { tostSetting } from "../../../helpers/scripts";

interface ordersState {
    orders: IOrder[];
    totalOrders: number;
    order: IOrder | null;
    codes: string[];
    currentCode: string;
    currentPage: number;
    selectedCount: number;
    isLoading: boolean;
    error: string;
}

const initialState: ordersState = {
    orders: [],
    codes: [],
    currentCode: "",
    totalOrders: 0,
    order: null,
    currentPage: 1,
    selectedCount: 0,
    isLoading: false,
    error: ''
};

const ordersSlice = createSlice({
    name: 'ordersSlice',
    initialState,
    reducers: {
        updateOrder(state, action) {
            if(state.order){
                state.order = {
                    ...state.order,
                    status: action.payload.status
                };
            }
            else{
                state.order = action.payload;
            }

        },
        setCurrentCode(state, action) {
            state.currentCode = action.payload;
        },
        setSelectedOrders(state, action) {
            const selectedList = action.payload;
            state.orders = state.orders.map(item => {
                if (selectedList?.includes(item.tg_user as string)) {
                    return {
                        ...item,
                        isSelected: true
                    }
                } else {
                    return {
                        ...item,
                        isSelected: false
                    }
                }
            });
        },
        setSelectedCount(state, action) {
            state.selectedCount = action.payload;
        },
        setCurrentPageOrders(state, action) {
            state.currentPage = action.payload;
        },
        resetOrders(state) {
            state = initialState;
        }
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(asyncGetOrdersAction.fulfilled, (state: any, action: PayloadAction<any>) => {
                const { rows, count } = action.payload;
                state.isLoading = false;
                state.error = '';
                state.totalOrders = count;
                const oldItems: string = localStorage.getItem('selectedEmail') ?? '';
                let oldArraySelected: string[] = oldItems ? oldItems?.split(',') : [];
                state.orders = rows ? rows.map((item: any) => {
                    if (oldArraySelected?.includes(item.email as string)) {
                        return {
                            ...item,
                            isSelected: true
                        }
                    } else {
                        return {
                            ...item,
                            isSelected: false
                        }
                    }
                }) : [];
            })
            .addCase(asyncGetOrdersAction.pending, (state: any, action: PayloadAction<any>) => {
                state.isLoading = true;
            })
            .addCase(asyncGetOrdersAction.rejected, (state: any, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(asyncGetOrderAction.fulfilled, (state:ordersState, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = '';
                state.order = action.payload;
            })
            .addCase(asyncGetOrderAction.pending, (state:ordersState, action: PayloadAction<any>) => {
                state.isLoading = true;
            })
            .addCase(asyncGetOrderAction.rejected, (state:ordersState, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(asyncUpdateOrderAction.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = '';
                state.order = action.payload;
                toast.success("Order successfully updated", tostSetting);
            })
            .addCase(asyncUpdateOrderAction.pending, (state: any, action: PayloadAction<any>) => {
                state.isLoading = true;
            })
            .addCase(asyncUpdateOrderAction.rejected, (state: any, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(asyncDeleteOrderAction.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = '';
                state.orders = state.orders.filter((item: IOrder) => item.id !== action.payload.id);
                toast.success("Order successfully deleted", tostSetting);
            })
            .addCase(asyncDeleteOrderAction.pending, (state: any, action: PayloadAction<any>) => {
                state.isLoading = true;
            })
            .addCase(asyncDeleteOrderAction.rejected, (state: any, action: PayloadAction<any>) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error("Can't delete order", tostSetting);
            });

    }
});

export const { updateOrder, setCurrentCode, setSelectedOrders, setSelectedCount, setCurrentPageOrders, resetOrders } = ordersSlice.actions;
export default ordersSlice.reducer;
